const emailRegExp = new RegExp("^[\\w!#$%&’*+/=?`{|}~^-]+(?:\\.[\\w!#$%&’*+/=?`{|}~^-]+)*@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{1,64}$")

export function isValidEmail(email: string) {
    
    return emailRegExp.test(email);
}